import {
  getFitnessPreferenceLabelByName,
  getNutritionPreferenceLabelByName,
} from 'dataLayer/api/apiDataMappingHelper';
import {
  exerciseAtom,
  nutritionAtom,
  userProfileAtom,
} from 'dataLayer/recoil/apiData/atoms';
import { selector } from 'recoil';

export const profileInfoDefaultSelector = selector({
  key: 'apiData/pages/myProfile/defaultSelectors/profileInfo',
  get: ({ get }) => {
    let userProfile = get(userProfileAtom);
    return { ...userProfile, extra_data: { ...userProfile.extra_data } };
  },
});

export const heightInputDefaultSelector = selector({
  key: 'apiData/pages/myProfile/defaultSelectors/heightInput',
  get: ({ get }) => {
    let userProfile = get(userProfileAtom);
    return userProfile.height; //TODO: use helper function which will check if userProfile is not undefined and has data field
  },
});

export const weightInputDefaultSelector = selector({
  key: 'apiData/pages/myProfile/defaultSelectors/weightInput',
  get: ({ get }) => {
    let userProfile = get(userProfileAtom);
    return userProfile.weight;
  },
});

export const userLanguageDefaultSelector = selector({
  key: 'apiData/pages/myProfile/defaultSelectors/weightInput',
  get: ({ get }) => {
    let userProfile = get(userProfileAtom);
    return userProfile.extra_data && userProfile.extra_data.language
      ? userProfile.extra_data.language
      : undefined;
  },
});

export const fitnessPreferencesCheckboxGroupDefaultSelector = selector({
  key:
    'apiData/pages/myProfile/defaultSelectors/fitnessPreferencesCheckboxGroup',
  get: ({ get }) => {
    let exerciseData = get(exerciseAtom);
    let fitnessPreferencesCheckboxGroupData = [];

    for (const key of Object.keys(exerciseData)) {
      fitnessPreferencesCheckboxGroupData.push({
        name: key,
        checked: exerciseData[key] ? exerciseData[key] : false,
        label: getFitnessPreferenceLabelByName(key),
      });
    }

    return fitnessPreferencesCheckboxGroupData;
  },
});

export const nutritionPreferencesCheckboxGroupDefaultSelector = selector({
  key:
    'apiData/pages/myProfile/defaultSelectors/nutritionPreferencesCheckboxGroup',
  get: ({ get }) => {
    let nutritionData = get(nutritionAtom);
    let nutritionPreferencesCheckboxGroupData = [];

    for (const key of Object.keys(nutritionData)) {
      if (
        ['vegetarian', 'vegan', 'pescatarian', 'pork_free', 'none'].includes(
          key
        )
      ) {
        nutritionPreferencesCheckboxGroupData.push({
          name: key,
          checked: nutritionData[key] ? nutritionData[key] : false,
          label: getNutritionPreferenceLabelByName(key),
        });
      }
    }

    return nutritionPreferencesCheckboxGroupData;
  },
});
